import React, { useState } from 'react'
import {
    ChatBubbleOutlineOutlined,
    FavoriteBorderOutlined,
    FavoriteOutlined,
    ShareOutlined,
  } from "@mui/icons-material";
import Friend from './Friend';
import { useDispatch, useSelector } from 'react-redux';
import { setPost } from '../redux/appSlice';

const PostCard = ({postId,postUserId,name,description,location,picturePath,userPicturePath,likes,comments,}
) => {
    const [isComments, setIsComments] = useState(false);
  const dispatch = useDispatch();
  const {token} = useSelector((state) => state.app);
  const loggedInUserId = useSelector((state) => state.app.user._id);
  const isLiked = Boolean(likes[loggedInUserId]);
  const likeCount = Object.keys(likes).length;

  const patchLike = async () => {
    const response = await fetch(`https://thoughtful-erin-oyster.cyclic.app/posts/${postId}/like`, {
      method: "PATCH",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ userId: loggedInUserId }),
    });
    const updatedPost = await response.json();
    dispatch(setPost({ post: updatedPost }));
  };
  return (
    <div className='flex flex-col gap-2 bg-white dark:bg-gray-900 rounded-md p-4 h-fit' >
        {/* row1 */}
        <Friend 
            friendId={postUserId}
            name={name}
            subTitle={location}
            userPicturePath={userPicturePath}
        />
        {/* row2 */}
        <div>
            <h3 className='text-xs text-gray-800 dark:text-white'>{description}</h3>
        </div>
        {/* row3 */}
        <div className='w-full h-auto'>
            {picturePath && (<img className='w-full h-full object-cover rounded-md' src={`${picturePath}`} alt="" />)}
        </div>
        {/* row4 */}
        <div className='flex justify-between items-center'>
            <div className='flex gap-3 items-center'>
                <div className='flex items-center gap-2 cursor-pointer' onClick={patchLike}>
                    {isLiked?(
                        <FavoriteOutlined className="svg-size text-rose-600"/>
                    ):(
                        <FavoriteBorderOutlined className="svg-size text-rose-600"/>
                    )}
                    <p className='text-xs text-gray-400'>{likeCount}</p>
                </div>
                <div className='flex items-center gap-2 cursor-pointer ' onClick={() => setIsComments(!isComments)}>
                    <ChatBubbleOutlineOutlined className="svg-size text-rose-600"/>
                    <p className='text-xs text-gray-400'>{comments.length}</p>
                </div>
            </div>
            <ShareOutlined className="svg-size text-rose-600"/>
        </div>
        {/* row5 */}
        {isComments && (
            <div className='flex flex-col '>
            <h3 className="text-sm text-gray-500 font-medium">comments</h3>
            <div className='flex flex-col text-xs text-gray-500 divide-y divide-gray-300'>
            {comments.map((comment,i)=>(
                <div className='mt-2' key={`${name}-${i}`}>
                    {comment}
                </div>
            ))}</div>
        </div>
        )}
    </div>
  )
}

export default PostCard